import React, { FC } from 'react';
import { Modal } from 'shared/ui/Modal';
import { Button } from 'shared/ui/Button';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ProfileVerificationStatus } from 'entities/User';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onUploadClick: () => void;
  status: ProfileVerificationStatus | null;
}

export const VerificationReminderModal: FC<Props> = ({ isOpen, onClose, onUploadClick, status }) => {
  const { t } = useAppTranslation(['profile', 'common']);

  const isRejected = status === ProfileVerificationStatus.REJECTED;

  if (!isRejected && status) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-[480px] w-full">
      <div className="text-center space-y-4">
        <div className="text-xl font-semibold text-primary font-tektur">
          {isRejected ? t('Your documents were rejected', { ns: 'profile' }) : t('Verification required', { ns: 'profile' })}
        </div>

        <div className="text-sm text-gray-600 leading-relaxed">
          {isRejected
            ? t('Your verification documents were rejected. Please upload new ones to continue using the platform.', {
                ns: 'profile',
              })
            : t('Please upload your identification documents to complete verification.', {
                ns: 'profile',
              })}
        </div>

        <div className="flex justify-center mt-6">
          <Button size="medium" containerClassName="w-full" onClick={onUploadClick}>
            {t('Go to docs upload form', { ns: 'profile' })}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
